import React from 'react';
import {
    Filter,
    SelectInput,
    TextInput
} from 'react-admin';
import {useTranslation} from 'react-i18next';

const ReceiverFilter = (props) => {
    const {t} = useTranslation();

    return (
        <Filter {...props}>
            <TextInput autoFocus label={t('Name')} source='name.value'/>
            <SelectInput source={'state.value'} choices={[
                {id: 'active', name: t('active')},
                {id: 'paused', name: t('paused')},
            ]} label={t('State')} allowEmpty={false}/>
        </Filter>
    );
}

export default ReceiverFilter;